import { isWithinLoginGracePeriod } from "~/lib/auth-grace-period";
import {
  fetchVerifiedCustomerSession,
  type VerifiedCustomerSessionResult,
} from "~/network/api";

const RETRY_DELAYS_AFTER_LOGIN_MS = [0, 300, 700, 1_500];
const RETRY_DELAYS_DEFAULT_MS = [0];

function retryDelaysMs(): number[] {
  return isWithinLoginGracePeriod()
    ? RETRY_DELAYS_AFTER_LOGIN_MS
    : RETRY_DELAYS_DEFAULT_MS;
}

function sleep(ms: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

/**
 * Verify bearer session with short retries right after login (cookie / webhook propagation).
 */
export async function verifyCustomerSessionWithRetry(): Promise<VerifiedCustomerSessionResult> {
  let last: VerifiedCustomerSessionResult = { error: "Session verification failed" };

  for (const delayMs of retryDelaysMs()) {
    if (delayMs > 0) await sleep(delayMs);
    last = await fetchVerifiedCustomerSession();
    if (!last.unauthorized) return last;
  }

  return last;
}

export function shouldTerminateForUnauthorized(
  unauthorized: boolean | undefined,
): boolean {
  if (!unauthorized) return false;
  return !isWithinLoginGracePeriod();
}
